import { createFromBaseNpcContext, constructNpcThroughTiersFromBase, constructNpcNaturalEquipmentFromBase,
    constructNpcTemplateSizeFromBase, constructNpcNestedGrantsFromBase, constructNpcIntegersFromBase } from '../compile/from-base-npc-stages';
import { constructNpcFeatIntegersFromBase } from '../compile/from-base-npc-feat-integers';
import { constructNpcStaticInventoryFromBase } from '../compile/from-base-npc-static-inventory';
import { deriveDefaultProviderNames } from '../compile/provider-catalog-order';
import type { FromBasePlayerResourceMetadata } from '../compile/from-base-player-resources';
import type { FromBaseInventoryMetadata } from '../compile/from-base-inventory';
import type { Row } from './row-plan';

/** Only the source values needed to create saved counters/loadouts. Reuse the
 * engine's grant and contribution readers; full skills, defenses, castable lists and
 * finalization belong to the newborn's one complete worker compile. */
export function constructSpawnInitializationSource(base: Row, metadata: FromBasePlayerResourceMetadata,
    inventory: FromBaseInventoryMetadata, classified: Row): Row {
    const context = createFromBaseNpcContext(base, metadata, inventory);
    const initial = { ...metadata, definitionLookup: context.definition };
    const counters = { ...initial,
        rollup: { ...metadata.rollup, integerLayers: ['aps', 'luck', 'v_dice', 'v_mod', 'v_temp', 'v_max_temp'] } };
    // Preserve the native pre-mirror boundary used by grant overrides.
    const bucket = classified.item_layer_types as Row;
    for (const key of [...deriveDefaultProviderNames(metadata.layerCatalog), ...metadata.abilityTypes,
        'feat', 'status_effect_permanent', 'spell_damage_resistance', 'spell_damage_vulnerability']) {
        if (!(key in bucket)) continue;
        classified[key] = bucket[key]; delete bucket[key];
    }
    let row = constructNpcThroughTiersFromBase(base, initial, inventory, classified);
    row = constructNpcNaturalEquipmentFromBase(base, initial, inventory, row);
    if (!Object.keys(context.ownReaders.layerEntries(classified, 'inventory_equipped')).length)
        row = constructNpcStaticInventoryFromBase(base, initial, inventory, row, false);
    row = constructNpcTemplateSizeFromBase(base, initial, inventory, row);
    row = constructNpcNestedGrantsFromBase(base, initial, inventory, row);
    row = constructNpcIntegersFromBase(base, counters, inventory, row);
    return constructNpcFeatIntegersFromBase(base, counters, row);
}
